import { useEffect, useState } from "react";

/**
 * Seconds since `key` last changed, ticking once a second while `key` is set —
 * the "(42s)" beside a long step that shows the page has not frozen.
 */
export default function useElapsedSeconds(key) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    setSeconds(0);
    if (!key) return undefined;
    const startedAt = Date.now();
    const timer = setInterval(() => setSeconds(Math.floor((Date.now() - startedAt) / 1000)), 1000);
    return () => clearInterval(timer);
  }, [key]);

  return seconds;
}
